export class LottteryFrequency
{

     //traduzir
     public static  getLabelToStatisticsFrequency(groupLen: number): string {
        let result = ""; // "Dezenas de maior frequência";

        if (groupLen == 1) {
            result += "Dezenas";
        }
        else if (groupLen == 2) {
            result += "Duques";
        }
        else if (groupLen == 3) {
            result += "Ternos";
        }
        else if (groupLen == 4) {
            result += "Quadras";
        }
        else if (groupLen == 5) {
            result += "Quinas";
        }
        else if (groupLen == 6) {
            result += "Senas";
        }

        if(result == "" && groupLen > 0)
        {
            return groupLen.toString() + " acertos";
        }
        return result;
    }
}